module.exports = __webpack_public_path__ + "static/img/logo_abft_new_alt.664fc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_abft_new_alt.png
// module id = bgSk
// module chunks = 1